import { DashboardT } from 'business/definitions';

export const sortDashboardsbyTitle = (dashboards: DashboardT[]): DashboardT[] =>
    dashboards.sort((a, b) =>
        a.title.localeCompare(b.title, undefined, { numeric: true }),
    );
